import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import MetricByFactorServices from "./MetricByFactor.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetMetricByFactor = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_METRIC_BY_FACTOR,
      payload: true,
    });
    console.log("hola")
    dispatch({
      type: actions.GET_METRIC_BY_FACTOR,
      payload: {
        metricByFactors: [],
        metricByFactorsLength: 0,
      },
    });
    dispatch({
      type: actions.METRIC_BY_FACTOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.METRIC_BY_FACTOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_METRIC_BY_FACTOR,
      payload: false,
    });
  }
};

export const getMetricByFactor = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_METRIC_BY_FACTOR,
      payload: true,
    });
    const resp = await MetricByFactorServices.getMetricByFactor(filters);
    dispatch({
      type: actions.GET_METRIC_BY_FACTOR,
      payload: {
        metricByFactors: resp.data.data,
        metricByFactorsLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.METRIC_BY_FACTOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.METRIC_BY_FACTOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_METRIC_BY_FACTOR,
      payload: false,
    });
  }
};

export const getMetricByFactorById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_METRIC_BY_FACTOR_BY_ID,
      payload: true,
    });
    const resp = await MetricByFactorServices.getMetricByFactorById(id);
    dispatch({
      type: actions.GET_METRIC_BY_FACTOR_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.METRIC_BY_FACTOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.METRIC_BY_FACTOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_METRIC_BY_FACTOR_BY_ID,
      payload: false,
    });
  }
};

export const saveMetricByFactor = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_METRIC_BY_FACTOR,
      payload: true,
    });
    const resp = await MetricByFactorServices.saveMetricByFactor(data);
    const { metricByFactors, metricByFactorsLength } = getState().metricByFactor;
    const _metricByFactors = [...metricByFactors, resp.data];
    dispatch({
      type: actions.GET_METRIC_BY_FACTOR,
      payload: {
        metricByFactors: _metricByFactors,
        metricByFactorsLength: metricByFactorsLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_METRIC_BY_FACTOR,
      payload: false,
    });
  }
};

export const editMetricByFactor = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_METRIC_BY_FACTOR,
      payload: true,
    });
    const resp = await MetricByFactorServices.editMetricByFactor(id, data);
    const { metricByFactors, metricByFactorsLength } = getState().metricByFactor;
    metricByFactors[index] = resp.data;
    dispatch({
      type: actions.GET_METRIC_BY_FACTOR,
      payload: {
        metricByFactors: metricByFactors,
        metricByFactorsLength: metricByFactorsLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_METRIC_BY_FACTOR,
      payload: false,
    });
  }
};

export const deleteMetricByFactor = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_METRIC_BY_FACTOR,
      payload: true,
    });
    await MetricByFactorServices.deleteMetricByFactor(id);
    const { metricByFactors, metricByFactorsLength } = getState().metricByFactor;
    metricByFactors.splice(index, 1);
    dispatch({
      type: actions.GET_METRIC_BY_FACTOR,
      payload: {
        metricByFactors: metricByFactors,
        metricByFactorsLength: metricByFactorsLength - 1,
      },
    });
    dispatch({
      type: actions.METRIC_BY_FACTOR_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data&&ex.response.data[0]){
              message = ex.response.data[0];
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_METRIC_BY_FACTOR,
      payload: false,
    });
  }
};